import { PartnerType } from '@/app/utils/partners.enum'
import { httpClient } from '../http/httpClient'

export interface importCustomerDataBody {
  schedule: string
  keys: string[]
  type?: PartnerType
}

export async function importCustomerData(body: importCustomerDataBody) {
  const { data } = await httpClient.post('/customer/import', body)

  return data
}
